import { Box, Typography, TypographyOwnProps } from '@mui/material';
import moment from 'moment';
import { useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { ASSUMPTION_EXCEPTION_STATUS, ASSUMPTION_STATUS, AssumptionType } from '../../types';
import { ASSUMPTION_STATUS_LABEL } from '../../CreateAndUpdateAssumption/constants';

const STATUS_COLOR: Record<string, TypographyOwnProps['color']> = {
  [ASSUMPTION_STATUS.VALID]: 'success',
  [ASSUMPTION_STATUS.VIOLATED]: 'error',
  [ASSUMPTION_STATUS.INACTIVE]: 'textSecondary',
};

const StatusField = () => {
  const { getData } = useFieldHelper<unknown>({ source: 'status' });
  const row = getData() as AssumptionType | undefined;

  if (!row?.status) return '-';

  const label = ASSUMPTION_STATUS_LABEL[row.status] ?? row.status;
  const isViolated = row.status === ASSUMPTION_STATUS.VIOLATED;
  const exceptionStatus = isViolated ? row.exceptionStatus : null;

  if (exceptionStatus === ASSUMPTION_EXCEPTION_STATUS.PENDING) {
    return (
      <Box>
        <Typography color="error">{label}</Typography>
        <Typography color="warning" variant="caption">
          Exception approval pending
        </Typography>
      </Box>
    );
  }

  if (
    exceptionStatus === ASSUMPTION_EXCEPTION_STATUS.APPROVED &&
    row.exceptionUntilDate &&
    !moment(row.exceptionUntilDate).isBefore(moment(), 'day')
  ) {
    return (
      <Box>
        <Typography color="error">{label}</Typography>
        <Typography color="textSecondary" variant="caption">
          Exception until {moment(row.exceptionUntilDate).format(DATE_FORMAT.FULL_DATE)}
        </Typography>
      </Box>
    );
  }

  if (exceptionStatus === ASSUMPTION_EXCEPTION_STATUS.REJECTED) {
    return (
      <Box>
        <Typography color="error">{label}</Typography>
        <Typography color="error.dark" variant="caption">
          Exception rejected
        </Typography>
      </Box>
    );
  }

  return <Typography color={STATUS_COLOR[row.status] ?? 'textPrimary'}>{label}</Typography>;
};

export default StatusField;
